import { Component, EventEmitter, Injector, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { MODAL, ModalService } from 'src/app/services/modal.service';
import { VALIDATION_COMPONENT_TYPE_ENUM } from '../validation.component';
import {
  BaseValidationProjectInfoModel,
  FidelityCardValidationModel,
} from 'src/app/models/configurators-2d/applications/kitchen/validation/base-validation-project-info';
import { CustomerService } from 'src/app/services/customer.service';

@Component({
  selector: 'ng-validation-project-info',
  templateUrl: './validation-project-info.component.html',
})
export class ValidationProjectInfoComponent implements OnInit, OnDestroy {
  @Input() model$: Observable<BaseValidationProjectInfoModel>;
  private _modelSubscription: Subscription;

  @Input() loading$: Observable<boolean>;
  private _loadingSubscription: Subscription;

  @Output() onRefreshRequested: EventEmitter<VALIDATION_COMPONENT_TYPE_ENUM> = new EventEmitter();

  private readonly renderPlaceholderUrl: string = 'assets/img/placeholders/hqrenders.jpg';

  public model: BaseValidationProjectInfoModel;
  public loading: boolean;
  public fidelityCardValidationModel: BehaviorSubject<FidelityCardValidationModel> =
    new BehaviorSubject<FidelityCardValidationModel>(undefined);

  public faSearch = faSearch;

  onError(event: Event) {
    (event.target as HTMLImageElement).src = this.renderPlaceholderUrl;
  }

  constructor(private readonly injector: Injector) {}

  ngOnInit(): void {
    this.subscribeToObservables();
  }

  get currentContext(): string {
    return this.injector.get(CustomerService).context;
  }

  ngOnDestroy(): void {
    this._modelSubscription?.unsubscribe();
    this._loadingSubscription?.unsubscribe();
  }

  private buildFidelityCardValidationModel() {
    this.fidelityCardValidationModel.next(this.model?.fidelityCardValidationModel);
  }

  private subscribeToObservables() {
    this._modelSubscription = this.model$.subscribe(model => {
      if (model) {
        this.model = model;
        this.buildFidelityCardValidationModel();
      }
    });

    this._loadingSubscription = this.loading$.subscribe(loading => (this.loading = loading));
  }

  refresh() {
    this.onRefreshRequested.emit();
  }

  openDetailCustomer() {
    const modalService = this.injector.get(ModalService);
    modalService.display(MODAL.REGISTER, {
      defaultEmail: this.model.customer.email,
      loadData: true,
      updateData: true,
      updateDataValidation: true,
      registerCallback: () => {
        modalService.display(MODAL.NONE);
        this.refresh();
      },
    });
  }
}
